import api from "@/api";
import axios from "axios";
import xml from "@/utils/xml";
import Vue from 'vue'

/* global X2JS */
const x2js = new X2JS();

const state = {
	krp: null,
	worksId: 0,
	groupId: 0,
	groupList: [],
	polylineList: [],
	sceneDetail: {},
	workDetail:{},
	materialId: 0,
	isFirstGroup: false,
	tabActive: "",
	activeGroupId:'',
	isTranslating:false,
	isCompareView:false,
	isShowViewer:false
};

const mutations = {
	SET_WORK_DETAIL(state, value) {
		state.workDetail = value;
	},
	
	SET_POLYLINE_LIST(state, value) {
		state.polylineList = value;
	},
	
	SET_MATERIAL_ID(state, value) {
		state.materialId = value;
	},
	
	SET_SCENE_DETAIL(state, value) {
		state.sceneDetail = value;
	},
	
	SET_KRP_INSTANCE(state, value) {
		state.krp = value;
	},
	
	SET_WORKS_ID(state, value) {
		state.worksId = value;
	},
	
	UPDATE_GROUP_LIST(state, value) {
		state.groupList = value;
	},
	
	UPDATE_ACTIVE_GROUP_ID(state, value) {
		state.activeGroupId = value;
	},
	
	UPDATE_IS_TRANSLATING(state, value) {
		state.isTranslating = value;
	},
	
	UPDATE_IS_COMPARE_VIEW(state, value) {
		state.isCompareView = value;
	},
	
	UPDATE_IS_SHOW_VIWER(state, value) {
		state.isShowViewer = value;
		if(!value){
			state.isCompareView = value;
		}
	},
	
};

const actions = {
	
	async showCompareView({commit,state,dispatch}){
		commit('UPDATE_IS_COMPARE_VIEW',true);
		await Vue.nextTick();
		let index = state.workDetail.sceneList.findIndex(item=>item.id == state.materialId);
		let groupId = state.groupList[state.groupList.length - 1].id;
		let sceneList = (await api.works.getWorksDetail({worksId:state.worksId,groupId})).data.sceneList;
		let materialId = sceneList[index].id;
		let sceneDetail = (await api.material.getSceneDetail({materialId})).data;
		let krp = await dispatch('getKrpInstance','pano2');
		await dispatch('loadKrp',{krp, sceneDetail });
	},
	
	hideCompareView({commit}){
		commit('UPDATE_IS_COMPARE_VIEW',false);
	},
	
	async getGroupList(context, worksId){
		try{
			let res = await api.group.listsAll({worksId});
			context.commit("UPDATE_GROUP_LIST", res.data);
			return res.data;
		}catch (e) {
			console.error(e)
		}
	},
	
	async getWorksDetail(context, {worksId,groupId}) {
		try {
			let res = await api.works.getWorksDetail({worksId,groupId});
			context.commit("SET_WORK_DETAIL", res.data);
			context.commit("SET_WORKS_ID", worksId);
			return res;
		} catch (e) {
			console.log(e);
		}
	},
	
	async getSceneDetail(context, {materialId}) {
		try {
			let res = await api.material.getSceneDetail({
				materialId
			});
			context.commit("SET_SCENE_DETAIL", res.data);
			return res.data;
		} catch (e) {
			console.error(e);
		}
	},
	
	
	async loadKrp(context, {krp, sceneDetail}) {
		let krpJson = await context.dispatch("getKrpJsonData", sceneDetail);
		let xml = x2js.json2xml_str(krpJson);
		krp.call("loadxml(" + xml + ")");
		krp.call(`loadscene(scene_${sceneDetail.id})`);
	},
	
	//krp-instance
	getKrpInstance(context, domId) {
		return new Promise(resolve => {
			/* global embedpano */
			embedpano({
				id: "krpanoSWFObject"+domId,
				xml: "",
				target: domId,
				html5: "only+webgl+preserveDrawingBuffer",
				mobilescale: 1.0,
				passQueryParameters: true,
				consolelog: true,
				onready: () => {
					let krpano = document.getElementById("krpanoSWFObject"+domId);
					if(domId == 'pano'){
						context.commit("SET_KRP_INSTANCE", krpano);
					}
					resolve(krpano);
				}
			});
		});
	},
	
	//krp-json-data
	getKrpJsonData(context, data) {
		return new Promise(resolve => {
			let request = axios.create({});
			request({url: "/krpano/vr-admin-xml/index.xml", method: "get"}).then(
				async res => {
					let xmlDoc = res.request.responseXML;
					let jsonXml = x2js.xml2json(xmlDoc);
					let scene = await context.dispatch("getKrpSceneData", data);
					jsonXml.krpano.scene = [scene];
					resolve(jsonXml);
				}
			);
		});
	},
	
	//krp-scene-data
	async getKrpSceneData(context, data) {
		let scene = await context.dispatch("getSceneData", data);
		return scene;
	},
	
	//json-scene
	getSceneData(context, data) {
		let info = data.info || {};
		let fov = info.fov || [];
		let hlookat = info.hlookat || [];
		let vlookat = info.vlookat || [];
		return xml.scene({
			material_id: data.id,
			stereographic: "true",
			name: data.name,
			cube_url: data.path + "/%s/l%l/%v/l%l_%s_%v_%h.jpg",
			multires: data.resolution ? data.resolution : "512,640,1280",
			preview_url: data.preview,
			hlookatmin: hlookat[0] || -180,
			hlookat: hlookat[1] || 0,
			hlookatmax: hlookat[2] || 180,
			vlookatmin: vlookat[0] || -90,
			vlookat: vlookat[1] || 0,
			vlookatmax: vlookat[2] || 90,
			fovmin: fov[0] || 30,
			fov: fov[1] || 95,
			fovmax: fov[2] || 140
		});
	
	},
	
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
